import { type Routes } from '@angular/router';
import { AuthLayout, MainLayout } from '@layouts';
import { authGuard, guestGuard } from '@core/guards';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [guestGuard],
    component: AuthLayout,
    children: [
      {
        path: '',
        loadChildren: () => import('@features/auth/login/login.routes').then((m) => m.LOGIN_ROUTES),
      },
    ],
  },
  {
    path: '',
    canActivate: [authGuard],
    component: MainLayout,
    children: [
      {
        path: 'chatbot',
        loadChildren: () => import('./features/chat/chat.routes').then((m) => m.CHAT_ROUTES),
      },
      {
        path: 'settings',
        loadChildren: () =>
          import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'chatbot',
      },
    ],
  },
];
